/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { AppContext } from '../../context/AppContextProvider'
import { apiOnGoingLotteries, apiPackages } from '../../services/api-service'
import { filter, trim } from 'lodash'
import { SalesType } from '../../util/constants'
import { numberWithCommas } from '../../util/util'
import MobileNumber from './MobileNumber'
import OtpNumber from './OtpNumber'
import { ModalContext } from '../../context/ModalContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { AuthContext } from '../../context/AuthContextProvider'
import PurchaseConfirm from './PurchaseConfirm'
import NICNumber from './NICNumber'
import PurchaseComplete from './PurchaseComplete'

const LottoBaseHome = () => {
  const { lotto } = useParams()
  const { lotteryState, setLotteryState, setPackageState, setSalesType } = useContext(AppContext)
  const { globalLoader, setGlobalLoader, setGlobalMessage, themeState, setThemeState } = useContext(MessageHandlerContext)
  const { authState } = useContext(AuthContext)
  const {
    mobileNumberModal, setMobileNumberModal,
    otpModal, setOtpModal,
    nicModal, setNicModal,
    purchaseCompleteModal, setPurchaseCompleteModal,
    purchaseConfirmModal, setPurchaseConfirmModal
  } = useContext(ModalContext)
  const [lotteryList, setLotteryList] = useState([])
  const [packageList, setPackageList] = useState([])

  useEffect(() => {
    setTheme()
    // loadLotteriesAndPackages()
  }, [])

  const setTheme = () => {
    switch (lotto) {
      case 'Govi Setha':
        setThemeState('gs')
        setLotteryState({ jackpot: window.env.GS_JACKPOT_PRICE, drawId: window.env.GS_DRAW_ID, draw_number: window.env.GS_DRAW, draw_date_time: window.env.GS_DRAW_DATE })
        setPackageState(window.env.GS_PACKAGE_ID)
        break
      case 'Supiri Vasana':
        setThemeState('sw')
        setLotteryState({ jackpot: window.env.SW_JACKPOT_PRICE, drawId: window.env.SW_DRAW_ID, draw_number: window.env.SW_DRAW, draw_date_time: window.env.SW_DRAW_DATE })
        setPackageState(window.env.SW_PACKAGE_ID)
        break
      case 'Mahajana Sampatha':
        setThemeState('ms')
        setLotteryState({ jackpot: window.env.MS_JACKPOT_PRICE, drawId: window.env.MS_DRAW_ID, draw_number: window.env.MS_DRAW, draw_date_time: window.env.MS_DRAW_DATE })
        setPackageState(window.env.MS_PACKAGE_ID)
        break
      case 'Dhana Nidhanaya':
        setThemeState('dn')
        setLotteryState({ jackpot: window.env.DN_JACKPOT_PRICE, drawId: window.env.DN_DRAW_ID, draw_number: window.env.DN_DRAW, draw_date_time: window.env.DN_DRAW_DATE })
        setPackageState(window.env.DN_PACKAGE_ID)
        break
      case 'Mega Power':
        setThemeState('mp')
        setLotteryState({ jackpot: window.env.MP_JACKPOT_PRICE, drawId: window.env.MP_DRAW_ID, draw_number: window.env.MP_DRAW, draw_date_time: window.env.MP_DRAW_DATE })
        setPackageState(window.env.MP_PACKAGE_ID)
        break
      case 'Vasana Sampatha':
        setThemeState('ws')
        setLotteryState({ jackpot: window.env.WS_JACKPOT_PRICE, drawId: window.env.WS_DRAW_ID, draw_number: window.env.WS_DRAW, draw_date_time: window.env.WS_DRAW_DATE })
        setPackageState(window.env.WS_PACKAGE_ID)
        break
      default:
        break
    }
  }

  const loadLotteriesAndPackages = async () => {
    setGlobalLoader(true)
    try {
      const lotteryPackages = await apiPackages()
      setPackageList(lotteryPackages.data)
      const lotteries = await apiOnGoingLotteries()
      setLotteryList(lotteries.data)
    } catch (error) {
      setGlobalMessage(error.message)
    } finally {
      setGlobalLoader(false)
    }
  }

  const onBuyClick = (type) => {
    // setLotteryState(lottery)
    setSalesType(type)
    // setPackageState(packageId)
    if (authState && authState.token) {
      setPurchaseConfirmModal(!purchaseConfirmModal)
    } else {
      setMobileNumberModal(!mobileNumberModal)
    }
  }

  // const renderLottery = () => {
  //   return lotteryList.map((lottery, index) => {
  //     const relatedPackage = filter(packageList.data, { package_name: lotto })
  //     return ((trim(lottery.lottery_name) === lotto)) && (
  //       <div key={index} className="py-2">
  //         {/* <div className="lotto_logo">
  //           <img src={`data:image/png;base64,${lottery.lottery_mobile_logo_url}`} width="80px" />
  //         </div> */}
  //         {
  //           (lottery.is_ongoing && !lottery.is_soldOut)
  //             ? (
  //               <>
  //                 {/* <div className="supperprice_title">
  //                   <img src={superPriceTitle} />
  //                 </div> */}
  //                 <div className={`prizeDetails ${themeState}`}>
  //                   <h2 className="prize">Rs. {window.env.WS_JACKPOT_PRICE ? numberWithCommas(window.env.REACT_APP_WS_JACKPOT_PRICE.toFixed(2)) : null}</h2>
  //                   <div className="drawDate">
  //                     Draw: {lottery.draw_number} | Date: {lottery.draw_date_time}
  //                   </div>
  //                 </div>
  //                 <div className="button">
  //                   <button className={`buy-button ${themeState}`} onClick={() => {
  //                     onBuyClick(lottery, relatedPackage[0].package_id, SalesType.ON_DEMAND)
  //                   }}>BUY NOW</button>
  //                 </div>
  //               </>
  //               )
  //             : (
  //               <div style={{ marginTop: 90 }}>
  //                 <div className="login_otp">
  //                   <div className="login_otp_wrapper text-center">
  //                     Why bother buying everyday,
  //                     subscribe once & receive lotteries everyday
  //                   </div>
  //                   <div className="button" style={{ top: 170 }}>
  //                     <button className={`buy-button ${themeState}`} onClick={() => {
  //                       onBuyClick(lottery, relatedPackage[0].package_id, SalesType.SUBSCRIPTION)
  //                     }}>SUBSCRIBE</button>
  //                   </div>
  //                 </div>
  //               </div>
  //               )
  //         }
  //       </div>
  //     )
  //   })
  // }

  const renderLottery = () => {
    return (
      <div className="py-2">
        <div className={`prizeDetails ${themeState}`}>
          <h2 className="prize">Rs. {lotteryState && lotteryState.jackpot ? numberWithCommas(lotteryState && lotteryState.jackpot.toFixed(2)) : null}</h2>
          <div className="drawDate">
            Draw: {lotteryState && lotteryState.draw_number} | Date: {lotteryState && lotteryState.draw_date_time}
          </div>
        </div>
        <div className="button">
          <button className={`buy-button ${themeState}`} onClick={() => {
            onBuyClick(SalesType.ON_DEMAND)
          }}>BUY NOW</button>
        </div>
      </div>
    )
  }

  return (
    <div className="pos-rel h-100">
      {
        !globalLoader && renderLottery()
      }
      {/* <div className="logo_lucky1">
        <img src={lucky1Logo} />
      </div> */}
      <MobileNumber opened={mobileNumberModal} toggle={() => setMobileNumberModal(!mobileNumberModal)} />
      <OtpNumber opened={otpModal} toggle={() => setOtpModal(!otpModal)} />
      <NICNumber opened={nicModal} toggle={() => setNicModal(!nicModal)} />
      <PurchaseConfirm opened={purchaseConfirmModal} toggle={() => setPurchaseConfirmModal(!purchaseConfirmModal)} />
      <PurchaseComplete opened={purchaseCompleteModal} toggle={() => setPurchaseCompleteModal(!purchaseCompleteModal)} />
    </div>
  )
}

export default LottoBaseHome
